export default __webpack_public_path__ + "static/media/portfolio.37317f30.jpg";